window.addEventListener('load', function(event) { 
  // console.log('resources loaded');

  // Vars
  let collection_types = [],
      resource_types = [],
      // product_types = [],
       resource_items = '',
      // product_items = '',
      resource_list = document.querySelector('.filter-list--resource');
      // product_list = document.querySelector('.filter-list--product');

  // Loop collections
  document.querySelectorAll('.filter-list__item[data-collection]').forEach(item => {
      collection_types.push(item.getAttribute('data-collection'));
  });

  // console.log('collection_types:')
  // console.log(collection_types)


  // Loop resource types
  document.querySelectorAll('.resources__grid .badge').forEach(item => {
    if (resource_types.indexOf(item.textContent) === -1) {
      resource_types.push(item.textContent);
    }
  });

  // Loop product types
  // document.querySelectorAll('.resources__grid .resources-card__type').forEach(item => {
  //   if (product_types.indexOf(item.textContent) === -1) {
  //     product_types.push(item.textContent);
  //   }
  // });

  // Sort Array by ABC
  resource_types = resource_types.sort();
  // product_types = product_types.sort();

  console.log('resource_types')
  console.log(resource_types)
  // Create the list items and put inside <ul>
  resource_types.forEach(type => {
    resource_items += `<li class="filter-list__item" data-resource="${type}">${type}</li>`;
  });

  // product_types.forEach(type => {
  //   product_items += `<li class="filter-list__item" data-product="${type}">${type}</li>`;
  // });

  resource_list.innerHTML = resource_items;
  //product_list.innerHTML = product_items;*/

  // Filter
  const resourceCards = Array.from(document.querySelectorAll('.resources-card'));
  const pagination = document.getElementById('resource-pagination');
  const pageSize = 15;
  let currentPage = 1;
  const maxVisiblePages = 3;
  let visibleCards;
  let pageCount = 1;

  const prevButton = document.querySelector('.pagination__prev');
  const nextButton = document.querySelector('.pagination__next');
  const resetFilterButton = document.querySelector('#resources-btn-reset');

  const partIdSearchInput = document.getElementById('part-id-search');
  partIdSearchInput.addEventListener('input', filterResources);

  function filterResources() {
    const partIdFilter = partIdSearchInput.value.trim().toLowerCase();
    const resourceTypeFilter = Array.from(document.querySelectorAll('.filter-list--resource .filter-list__item.filter-list__item--active')).map(item => item.dataset.resource.toLowerCase());
    // const productTypeFilter = Array.from(document.querySelectorAll('.filter-list--product .filter-list__item.filter-list__item--active')).map(item => item.dataset.product.toLowerCase());
    const productCollectionFilter = Array.from(document.querySelectorAll('.filter-list--collection .filter-list__item.filter-list__item--active')).map(item => item.dataset.collection.toLowerCase());


    resourceCards.forEach(card => {
      const resourceType = card.dataset.resource.toLowerCase();
      // const productType = card.dataset.product.toLowerCase();
      const collectionTypeString = card.dataset.collection.toLowerCase();
      //collectionType.push(card.dataset.collection.toLowerCase());
      const collectionType = collectionTypeString.split(",");
      const collectionNames = card.querySelectorAll('.resources-card__collection')[0];

      // console.log('collectionType:')
      // console.log(collectionType)

      let collectionNames_intersection = collection_types.filter(x => collectionType.includes(x));

      // console.log('intersection:')
      // console.log(collectionNames_intersection)

      let  collectionNames_final = [];
      collectionNames_intersection.forEach(element => {
        document.querySelectorAll('.filter-list--collection li[data-collection="'+element+'"]').forEach(item => {
          collectionNames_final.push(item.textContent);
        });
      });


      var collectionNames_content = document.createTextNode(collectionNames_final);
      collectionNames.innerHTML = "";
      collectionNames.appendChild(collectionNames_content);

      //for search
      const partId = card.dataset.sku.toLowerCase();
      const title = card.querySelector('.resources-card__title').textContent.toLowerCase();

      function haveCommonItems(collectionType, productCollectionFilter) {
        const set1 = new Set(collectionType);
        const commonItems = productCollectionFilter.filter(item => set1.has(item));
        return commonItems.length > 0;
      }

      const resourceTypeMatch = resourceTypeFilter.length === 0 || resourceTypeFilter.includes(resourceType);
      // const productTypeMatch = productTypeFilter.length === 0 || productTypeFilter.includes(productType);
      const collectionTypeMatch = productCollectionFilter.length === 0 || haveCommonItems(collectionType, productCollectionFilter);
      const partIdMatch = partId.includes(partIdFilter);
      const titleMatch = title.includes(partIdFilter);

      // console.log('collectionType:')
      // console.log(collectionType)
      // if (collectionType.indexOf(productCollectionFilter[0]) > -1) {
      //   console.log('=====================================')
      //   console.log('collectionTypeMatch')
      //   console.log(collectionTypeMatch)
      //   console.log('productCollectionFilter:')
      //   console.log(productCollectionFilter)
      //   console.log('collectionType:')
      //   console.log(collectionType)
      //   console.log('=====================================')
      // }else{
        //console.log('ne')
      // }
      //if (resourceTypeMatch && productTypeMatch && (partIdMatch || titleMatch)) {
      if (resourceTypeMatch && collectionTypeMatch && (partIdMatch || titleMatch)) {
          card.style.display = 'block';
        } else {
          card.style.display = 'none';
        }
    });

    visibleCards = resourceCards.filter(card => card.style.display !== 'none');

    createPagination();

    // Show the first page by default
    showPage(1, visibleCards);
  }

  function createPagination() {
    visibleCards = resourceCards.filter(card => card.style.display !== 'none');
    pageCount = Math.ceil(visibleCards.length / pageSize);

    updatePagination(pageCount, visibleCards);

    // Remove previous event listeners
    prevButton.removeEventListener('click', handlePrevClick);
    nextButton.removeEventListener('click', handleNextClick);

    // Add event listeners for pagination buttons
    prevButton.addEventListener('click', handlePrevClick);
    nextButton.addEventListener('click', handleNextClick);
  }

  function handlePrevClick() {
    if (currentPage > 1) {
      currentPage--;
      showPage(currentPage, visibleCards);
      updatePagination(pageCount, visibleCards);
    }
  }

  function handleNextClick() {
    if (currentPage < pageCount) {
      currentPage++;
      showPage(currentPage, visibleCards);
      updatePagination(pageCount, visibleCards);
    }
  }

  function updatePagination(pageCount, visibleCards) {
    if (visibleCards.length == 0) {
      document.querySelector('.resources__pagination-wrapper').style.display = 'none';
      document.querySelector('.resources__warning').style.display = 'block';
    } else {
      document.querySelector('.resources__pagination-wrapper').style.display = 'block';
      document.querySelector('.resources__warning').style.display = 'none';
    }
    window.scrollTo(0, 0);

    let startPage = Math.max(1, currentPage - 2);
    let endPage = Math.min(pageCount, currentPage + 2);

    if (endPage - startPage < maxVisiblePages - 1) {
      if (currentPage < pageCount / 2) {
        endPage = Math.min(pageCount, startPage + maxVisiblePages - 1);
      } else {
        startPage = Math.max(1, endPage - maxVisiblePages + 1);
      }
    }

    pagination.innerHTML = '';

    if (startPage > 1) {
      const pageButton1 = document.createElement('button');
      pageButton1.innerText = 1;
      pageButton1.classList.add('page', 'text-pagination-x-small');
      pageButton1.setAttribute('aria-label', 'Page 1');

      pageButton1.addEventListener('click', function () {
        currentPage = 1;
        showPage(currentPage, visibleCards);
        updatePagination(pageCount, visibleCards);
      });

      pagination.appendChild(pageButton1);

      if (startPage > 2) {
        pagination.appendChild(createEllipsis());
      }
    }

    for (let i = startPage; i <= endPage; i++) {
      const pageButton = document.createElement('button');
      pageButton.innerText = i;
      pageButton.classList.add('page', 'text-pagination-x-small');
      pageButton.setAttribute('aria-label', `Page ${i}`);

      if (i === currentPage) {
        pageButton.classList.add('current');
      }

      pageButton.addEventListener('click', function () {
        currentPage = i;
        showPage(currentPage, visibleCards);
        updatePagination(pageCount, visibleCards);
      });
      pagination.appendChild(pageButton);
    }

    if (endPage < pageCount) {
      if (endPage < pageCount - 1) {
        pagination.appendChild(createEllipsis());
      }
      const lastPageButton = document.createElement('button');
      lastPageButton.innerText = pageCount;
      lastPageButton.classList.add('page', 'text-pagination-x-small');
      lastPageButton.setAttribute('aria-label', `Page ${pageCount}`);

      if (currentPage === pageCount) {
        lastPageButton.classList.add('current');
      }

      lastPageButton.addEventListener('click', function () {
        currentPage = pageCount;
        showPage(currentPage, visibleCards);
        updatePagination(pageCount, visibleCards);
      });

      pagination.appendChild(lastPageButton);
    }

    if (currentPage === 1) {
      prevButton.classList.add('pagination__btn--disable');
    } else {
      prevButton.classList.remove('pagination__btn--disable');
    }

    if (currentPage === pageCount) {
      nextButton.classList.add('pagination__btn--disable');
    } else {
      nextButton.classList.remove('pagination__btn--disable');
    }
  }

  function createEllipsis() {
    const ellipsis = document.createElement('span');
    ellipsis.innerText = '…';
    ellipsis.classList.add('page', 'text-pagination-x-small');
    return ellipsis;
  }

  function showPage(page, visibleCards) {
    const start = (page - 1) * pageSize;
    const end = start + pageSize;
    visibleCards.forEach((card, index) => {
      if (index >= start && index < end) {
        card.style.display = 'block';
      } else {
        card.style.display = 'none';
      }
    });
  }

  function toggleFilterItem(element) {
    element.classList.toggle('filter-list__item--active');
    filterResources();
  }

  document.querySelectorAll('.filter-list__item').forEach(item => {
    item.addEventListener('click', function() {
      toggleFilterItem(this);
    });
  });

  function resetFilters() {
    // Reset selected filter items
    document.querySelectorAll('.filter-list__item.filter-list__item--active').forEach(item => {
      item.classList.remove('filter-list__item--active');
    });

    partIdSearchInput.value = '';

    // Reset pagination and show all resource cards
    currentPage = 1;
    resourceCards.forEach(card => {
      card.style.display = 'block';
    });
    filterResources();
  }

  filterResources();

  resetFilterButton.addEventListener('click', resetFilters);

  // Mobile triggers
  document.querySelector('.resources__trigger').addEventListener('click', function(){
    document.querySelector('.resources__filter').classList.toggle('resources__filter--active');
  });

  document.querySelector('.resources__icon-close').addEventListener('click', function(){
    document.querySelector('.resources__filter').classList.remove('resources__filter--active');
  })

  //Pre-filter on load
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const preFilter = urlParams.get('resource-type');
  switch (preFilter) {
    case 'info-sheet':
      document.querySelector('.filter-list__item[data-resource="Info Sheet"]').click();
      // document.querySelector('.resources__title h1').textContent = "Info Sheets";
      break;
    case 'user-manual':
      document.querySelector('.filter-list__item[data-resource="User Manual"]').click();
      // document.querySelector('.resources__title h1').textContent = "User Manuals";
      break;
    case 'dimensional-drawings':
      document.querySelector('.filter-list__item[data-resource="Dimensional Drawing"]').click();
      // document.querySelector('.resources__title h1').textContent = "Dimensional Drawings";
      break;
    case 'plumbing-wiring':
      document.querySelector('.filter-list__item[data-resource="Plumbing Diagram"]').click();
      document.querySelector('.filter-list__item[data-resource="Wiring Diagram"]').click();
      // document.querySelector('.resources__title h1').textContent = "Wiring & Plumbing Diagrams";
      break;
  }


}, false);